'use client';

import React, { useEffect } from 'react';

const CalendlyWidget = () => {
  useEffect(() => {
    const calendly = window.Calendly;
    const container = document.querySelector('.calendly-inline-widget');

    if (calendly && container && container.childNodes.length === 0) {
      calendly.initInlineWidget({
        url: 'https://calendly.com/d/cr8y-5pt-7bv?hide_gdpr_banner=1',
        parentElement: container,
      });
    }
  }, []);

  return (
    <div
      data-url="https://calendly.com/d/cr8y-5pt-7bv?hide_gdpr_banner=1"
      className="calendly-inline-widget h-3xl min-w-xs"
    ></div>
  );
};

export default CalendlyWidget;
